import logo from "assets/images/brands/logo_converted.png";

export const clientName = "Maasgain Global";
export const developedBy = "Maasgain Global";
export const imagesUrl = process.env.REACT_APP_API_IMAGES_URL;
export const cpUrl = process.env.REACT_APP_CP_URL;
export const apiUrl = process.env.REACT_APP_API_CP_DOMAIN;
export const companyName =  "Maasgain Global";
export const companyWebsite = "#";
export const privacyPolicyLink = "#";
export const clientAgreementLink = "#";
export const sidebarLogo = logo;
export const smLogo = logo;
export const mainLogo = logo;
export const footerLogo = logo;
